import { memo, type SVGProps } from 'react'

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m4 12 12-9.334L28 12v14.666a2.667 2.667 0 0 1-2.667 2.667H6.667A2.667 2.667 0 0 1 4 26.667V12Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Memo = memo(SvgHome)
export default Memo
